var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"research-details"},[_c('Header'),_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',{staticClass:"mt-5"},[_c('b-col',[_c('h1',[_vm._v("Research Detail Coming soon")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }